import { CommonModule, Location } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import { TranslateService } from '@ngx-translate/core';

import { cloneDeep } from 'lodash-es';

import {
    CheckUserEmailRequestDTO,
    EditorBaseComponent,
    GlobalsService,
    MetaService,
    UnknownErrorCallingAPIMessage,
    UserAccountInformationDTO,
    UserContextRoleDTO,
    UserContextRoleInformationDTO,
    doCheckUserEmail,
    isAssigned,
    isEmailValid,
} from '../../data';
import { Router } from '@angular/router';

@Component({
    selector: 'app-user-context-role-account-editor-base',
    template: '',
    standalone: true,
    imports: [CommonModule],
})
export class UserContextRoleAccountEditorBase extends EditorBaseComponent {
    protected _isInternal = false;

    isLoadingCheckUserEmail = false;
    userEmailExists?: boolean;

    @Input()
    isNewUser = false;

    @Input()
    canEdit = false;
    get cannotEdit(): boolean {
        return !this.canEdit;
    }

    private _accountInfo: UserAccountInformationDTO = {};
    @Input()
    set accountInfo(ai: UserAccountInformationDTO | undefined) {
        this._accountInfo = ai ?? {};
        this._accountInfo.isInternal = this._isInternal;

        if (!isAssigned(this._contextRole.information)) {
            this._contextRole.information = { userRoleContextId: this._contextRole.userRoleContextId };
        }
        this._contextRole.information!.userEmail = this._contextRole.information?.userEmail ?? this._accountInfo.userEmail;

        this.emitOnChanged();
    }
    get accountInfo(): UserAccountInformationDTO {
        return this._accountInfo;
    }

    private _contextRole: UserContextRoleDTO = { userRoleContextId: -1 };
    private _contextRoleO: UserContextRoleDTO = { userRoleContextId: -1 };
    @Input()
    set contextRole(cr: UserContextRoleDTO | undefined) {
        this._contextRole = cr ?? { userRoleContextId: -1 };

        if (!isAssigned(this._contextRole.information)) {
            this._contextRole.information = { userRoleContextId: this._contextRole.userRoleContextId };
        }
        this._contextRole.information!.userEmail = this._contextRole.information?.userEmail ?? this._accountInfo.userEmail;

        this._contextRoleO = cloneDeep(this._contextRole);
        this.emitOnChanged();
    }
    get contextRole(): UserContextRoleDTO {
        return this._contextRole;
    }
    get contextRoleO(): UserContextRoleDTO {
        return this._contextRoleO;
    }

    get contextRoleInfo(): UserContextRoleInformationDTO {
        return this._contextRole.information ?? { userRoleContextId: this._contextRole.userRoleContextId };
    }

    constructor(
        private readonly _router: Router,
        translateSrv: TranslateService,
        toastr: ToastrService,
        globals: GlobalsService,
        metaSrv: MetaService,
        location: Location,
    ) {
        super(translateSrv, toastr, globals, metaSrv, location);
    }

    override get isLoadingInternal(): boolean {
        return super.isLoadingInternal || this.isLoadingCheckUserEmail;
    }

    get isEmailValid(): boolean {
        return (
            isAssigned(this.contextRole.information?.userEmail) &&
            this.contextRole.information?.userEmail !== '' &&
            isEmailValid(this.contextRole.information!.userEmail!)
        );
    }

    get userId(): number | string | undefined {
        return this.contextRole.information!.userId;
    }

    override get hasChanged(): boolean {
        return (
            this.contextRole.information?.userEmail !== this.contextRoleO.information?.userEmail ||
            this.contextRole.information?.secondaryEmail !== this.contextRoleO.information?.secondaryEmail
        );
    }

    protected checkUserEmail() {
        this.userEmailExists = undefined;
        this.emitOnLoading();
        this.emitOnChanged();

        if (this.isEmailValid) {
            doCheckUserEmail(
                this.metaSrv,
                this._contextRole.information?.userEmail ?? '',
                (isLoading) => {
                    this.isLoadingCheckUserEmail = isLoading;

                    this.emitOnLoading();
                },
                (userId) => {
                    this.userEmailExists = isAssigned(userId) && userId! > 0;
                    this.contextRole.information!.userId = userId;
                    this.emitOnChanged();
                },
            );

            //             this.isLoadingCheckUserEmail = true;
            //             this.emitOnLoading();

            //             const request: CheckUserEmailRequestDTO = { userEmail: this._contextRole.information?.userEmail };

            // )            this.metaSrv.checkUserEmail(request).subscribe({
            //                 next: (response) => {
            //                     this.isLoadingCheckUserEmail = false;

            //                     this.userEmailExists = response.exist;

            //                     this.emitOnLoading();
            //                     this.emitOnChanged();
            //                 },
            //                 error: (error) => {
            //                     this.isLoadingCheckUserEmail = false;
            //                     this.emitOnLoading();

            //                     if (this.isNewUser && error.status === 409) {
            //                         this.userEmailExists = false;
            //                         this.emitOnChanged();
            //                     } else {
            //                         this.userEmailExists = undefined;
            //                         this.toastrError(error.message ?? UnknownErrorCallingAPIMessage);
            //                     }
            //                 },
            //             });
        }
    }

    gotoUserAccount() {
        this.goBack(() => {
            this._router.navigate(['/account-information', this.userId, 'info']);
        });
    }
}
